module.exports = __webpack_public_path__ + "img/arrow.d9c9f34b.svg";